









































import { Component, Vue, Prop } from "vue-property-decorator";
import LoginForgotPassword from "@/components/login/LoginForgotPassword.vue";
import LoginReset from "@/components/login/LoginReset.vue";
import LoginSet from "@/components/login/LoginSet.vue";
import LoginEnterPassword from "@/components/login/LoginEnterPassword.vue";
import { LoginCardEnum } from "@/store/enum/loginCardEnum";
import Logout from "@/components/login/LoginLogout.vue";

@Component({
  components: { LoginForgotPassword, LoginReset, LoginSet, LoginEnterPassword, Logout }
})
export default class LoginCard extends Vue {
  @Prop()
  onLogin?: Function;

  @Prop({ default: LoginCardEnum.LOGIN })
  initialSelectedCard?: LoginCardEnum.LOGIN;

  password = "";
  mail = "";

  code = this.$route.query.code || this.$route.params.code || "";

  selectedCard = this.initialSelectedCard || LoginCardEnum.LOGIN;

  LoginCardEnum = LoginCardEnum;

  isBackToLoginResetVisible = false;

  constructor() {
    super();
  }

  get previousPassword() {
    return this.$route.query.initialonetimepassword || this.$route.params.initialOneTimePassword || this.password || "";
  }

  showBackToLoginReset() {
    this.isBackToLoginResetVisible = true;
  }

  changeMail(newMail: string) {
    this.mail = newMail;
  }

  changePassword(newPassword: string) {
    this.password = newPassword;
  }

  showLoginCard() {
    this.selectedCard = LoginCardEnum.LOGIN;
  }

  changePasswordCard(newCard: LoginCardEnum) {
    this.selectedCard = newCard;
  }

  async beforeMount() {
    if (["/reset/", "/reset", "/login/reset", "/login/reset/"].includes(this.$route.path)) {
      //show reset password card
      this.selectedCard = LoginCardEnum.RESET;
    } else {
      if (["/set/", "/set", "/login/set", "/login/set/"].includes(this.$route.path)) {
        //show New password card
        this.selectedCard = LoginCardEnum.SET;
      } else {
        if (["/forgot/", "/forgot", "/login/forgot", "/login/forgot/"].includes(this.$route.path)) {
          //show forgot password card
          this.selectedCard = LoginCardEnum.FORGOT;
        } else {
          if (["/logout/", "/logout", "/login/logout", "/login/logout/"].includes(this.$route.path)) {
            this.selectedCard = LoginCardEnum.LOGOUT;
          } else {
            this.selectedCard = LoginCardEnum.LOGIN;
          }
        }
      }
    }
  }
}
